import qs from "query-string";
import {
  ParamKeyValuePair,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { useQueryString } from "./useQueryString";
import { useReactRouterLink } from "./useReactRouterLink";

export const useQueryStringFilter = (defaultInit: ParamKeyValuePair[]) => {
  let [, setSearchParams] = useSearchParams(defaultInit);
  const { navigate } = useReactRouterLink();

  const location = useLocation();
  const queryParam = qs.parse(location.search);

  const query = useQueryString();

  const setQueryStringFilter = (queryKey: string, value: string) => {
    const queryValue = query.get(queryKey);
    if (!value && (queryValue === null || queryValue?.trim() === "")) return;

    const newQueryParam = {
      ...queryParam,
      [queryKey]: value,
    };

    setSearchParams(qs.stringify(newQueryParam), { replace: true });
  };

  const seturlQueryStringFilter = (urlParam: object, useFilter = false) => {
    const newQueryParam = {
      ...queryParam,
      ...urlParam,
    };
    // console.log("useQueryStringFilter urlParam:", qs.stringify(urlParam));
    // console.log(
    //   "useQueryStringFilter newQueryParam:",
    //   qs.stringify(newQueryParam)
    // );

    setSearchParams(qs.stringify(newQueryParam), { replace: true });
  };

  const clearQueryStringFilter = (queryKey: string) => {
    const {
      // [queryKey],
      ...restQueryParams
    } = queryParam;
    // location.search.replace(queryKey, null);

    setSearchParams(qs.stringify(restQueryParams), { replace: true });
  };

  const clearAllQueryStringsWithPrefix = (prefix: string) => {
    const query = new URLSearchParams(location.search);
    const queryParamsToRemove: string[] = [];
    // console.log("clearAllQueryStringsWithPrefix: RUNNING");

    // Iterate through all query parameters
    for (const [key, value] of query.entries() as any) {
      // console.log("evaluating key: ", key);

      if (key.startsWith(prefix)) {
        // Add parameters with the specified prefix to the removal list
        queryParamsToRemove.push(key);
        // console.log("pushing key: ", key);
      }
    }

    // Remove query parameters with the specified prefix
    queryParamsToRemove.forEach((key) => query.delete(key));

    // Create a new location object with the modified query string
    const newSearch = query.toString();
    const newPath = `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;

    // Replace the current location with the modified one
    // history.replace(newPath);
    // console.log("navigate with new search: ", newSearch);
    navigate({
      pathname: location.pathname,
      search: newSearch ? `?${newSearch}` : "",
    });
  };

  return {
    setQueryStringFilter,
    clearQueryStringFilter,
    clearAllQueryStringsWithPrefix,
    seturlQueryStringFilter,
  };
};
